import * as types from './venue.types'

export const actions = {
  toggleLoading: payload => ({
    type: types.TOGGLE_LOADING,
    payload,
  }),
  toggleSuccess: payload => ({
    type: types.TOGGLE_SUCCESS,
    payload,
  }),
  get: payload => ({
    type: types.GET_VENUE,
    payload,
  }),
  set: payload => ({
    type: types.SET_VENUE,
    payload,
  }),
  create: payload => ({
    type: types.CREAT_VENUE,
    payload,
  }),
  edit: payload => ({
    type: types.EDIT_VENUE,
    payload,
  }),
  remove: payload => ({
    type: types.DELETE_VENUE,
    payload,
  }),
  setPermissions: payload => ({
    type: types.SET_PERMISSIONS,
    payload,
  }),
  setErrors: payload => ({
    type: types.SET_ERRORS,
    payload,
  }),
  clearData: payload => ({
    type: types.CLEAR_DATA,
    payload,
  }),
}
